import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppTypePhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "appType-Phone",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17532",
		"data-name": "Group 17532",
		transform: "translate(3.333 2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12967",
				"data-name": "Path 12967",
				d: "M8.171,10.246c.964.965,2.186,1.58,2.913.856l.176-.176a.531.531,0,0,0-.071-.813l-.561-.392a.536.536,0,0,0-.684.057l-.2.2a4.272,4.272,0,0,1-.718-.584h0a4.255,4.255,0,0,1-.584-.718l.2-.2A.536.536,0,0,0,8.7,7.789c-.144-.2-.273-.389-.392-.561a.531.531,0,0,0-.813-.071l-.176.176c-.723.727-.109,1.948.856,2.913",
				transform: "translate(-1.098 1)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12958",
				"data-name": "Path 12958",
				d: "M14.333,9V6.219a1.334,1.334,0,0,0-.391-.943L12.057,3.391A1.334,1.334,0,0,0,11.115,3H6.333A1.333,1.333,0,0,0,5,4.333v9.333A1.333,1.333,0,0,0,6.333,15H9",
				transform: "translate(-5 -3)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12959",
				"data-name": "Path 12959",
				d: "M8,9h5.333",
				transform: "translate(-6 -5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12960",
				"data-name": "Path 12960",
				d: "M8,12h5.333",
				transform: "translate(-6 -6)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12961",
				"data-name": "Path 12961",
				d: "M8,15H9.333",
				transform: "translate(-6 -7)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12964",
		"data-name": "Path 12964",
		d: "M0,0H16V16H0Z",
		fill: "none"
	})]
});
export default SvgAppTypePhone;
